import Vue from "vue";
import VueRouter from "vue-router";

// ============================== Start Views ==============================
// Home
import Home from "../views/Home.vue";

// ********** Children
import HomePage from "../views/children/HomePage.vue";

// ========== Start Profiles ==========

// ========== End Profiles ==========

// ============================== START:: CRUDS ==============================

// ******* Start Cancel Reasons *******
import CancelReasonsHome from "../views/children/CRUDS/CancelReasons/Home.vue";
// Show All
import AllCancelReasons from "../views/children/CRUDS/CancelReasons/ShowAll.vue";
// Show Single
import CancelReasonShow from "../views/children/CRUDS/CancelReasons/Show.vue";
// Add/Edit
import CancelReasonForm from "../views/children/CRUDS/CancelReasons/Form.vue";
// ******* End Cancel Reasons *******

// ******* Start Report Reasons *******
import ReportReasonsHome from "../views/children/CRUDS/ReportReasons/Home.vue";
// Show All
import AllReportReasons from "../views/children/CRUDS/ReportReasons/ShowAll.vue";
// Show Single
import ReportReasonShow from "../views/children/CRUDS/ReportReasons/Show.vue";
// Add/Edit
import ReportReasonForm from "../views/children/CRUDS/ReportReasons/Form.vue";
// ******* End Report Reasons *******

// ============================== START:: CRUDS ==============================

// ========== Start:: Static Screens ==========
import StaticScreens from "../views/children/StaticScreens/Home.vue";
// ========== End:: Static Screens ==========

// ========== Start:: Settings ==========
// *********** ABOUT
import AboutUsHome from "../views/children/Settings/AboutUs/Home.vue";
// Show All

// Add/Edit
import AboutUsForm from "../views/children/Settings/AboutUs/Form.vue";

// *********** Terms
import TermsHome from "../views/children/Settings/Terms/Home.vue";
// Show All

// Add/Edit
import TermsForm from "../views/children/Settings/Terms/Form.vue";

// *********** Policy
import PolicyHome from "../views/children/Settings/Policy/Home.vue";
// Show All

// Add/Edit
import PolicyForm from "../views/children/Settings/Policy/Form.vue";

// ========== End:: Settings ==========

// ========== Start:: Reference ==========
import Reference from "../Reference/Reference.vue";
// ========== End:: Reference ==========

// ********** Auth
import Login from "../views/Auth/Login.vue";

// ********** PolicyPage (Standalone)
import PolicyPage from "../views/PolicyPage.vue";

// ********** NotFound
import NotFound from "../views/NotFound.vue";
// ============================== End Views ==============================

// Vuex store
import store from "../store/index";
let router = null;
window.rootRouter = router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    // Main
    {
      path: "/",
      component: Home,
      children: [
        {
          path: "/",
          name: "HomePage",
          component: HomePage,
        },

        // ============================== Start CRUDS ==============================
        // ******* Start Countries *******
        {
          path: "/countries",
          component: () => import("../views/children/CRUDS/Countries/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllCountries",
              component: () =>
                import("../views/children/CRUDS/Countries/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "CountryShow",
              component: () =>
                import("../views/children/CRUDS/Countries/Show.vue"),
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "CountryEdit",
              component: () =>
                import("../views/children/CRUDS/Countries/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "CountryAdd",
              component: () =>
                import("../views/children/CRUDS/Countries/Form.vue"),
            },
          ],
        },
        // ******* End Countries *******
        // ******* Start reason-leaves *******
        {
          path: "/reason-leaves",
          component: () =>
            import("../views/children/CRUDS/leaveReasons/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllleaveReasons",
              component: () =>
                import("../views/children/CRUDS/leaveReasons/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "leaveShow",
              component: () =>
                import("../views/children/CRUDS/leaveReasons/Show.vue"),
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "leaveEdit",
              component: () =>
                import("../views/children/CRUDS/leaveReasons/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "leaveAdd",
              component: () =>
                import("../views/children/CRUDS/leaveReasons/Form.vue"),
            },
          ],
        },
        // ******* End reason-leaves *******
        // ******* Start questionCategories *******
        {
          path: "/question-category",
          component: () =>
            import("../views/children/CRUDS/questionCategories/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllquestionCategories",
              component: () =>
                import(
                  "../views/children/CRUDS/questionCategories/ShowAll.vue"
                ),
            },
            // Show Single
            {
              path: "show/:id",
              name: "question-categoryShow",
              component: () =>
                import("../views/children/CRUDS/questionCategories/Show.vue"),
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "question-categoryEdit",
              component: () =>
                import("../views/children/CRUDS/questionCategories/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "question-categoryAdd",
              component: () =>
                import("../views/children/CRUDS/questionCategories/Form.vue"),
            },
          ],
        },
        // ******* End questionCategories *******

        // ******* Start Cities *******
        {
          path: "/cities",
          component: () => import("../views/children/CRUDS/Cities/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllCities",
              component: () =>
                import("../views/children/CRUDS/Cities/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "CityShow",
              component: () =>
                import("../views/children/CRUDS/Cities/Show.vue"),
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "CityEdit",
              component: () =>
                import("../views/children/CRUDS/Cities/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "CityAdd",
              component: () =>
                import("../views/children/CRUDS/Cities/Form.vue"),
            },
          ],
        },
        // ******* End Cities *******

        // ******* Start Areas *******
        {
          path: "/areas",
          component: () => import("../views/children/CRUDS/Areas/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllAreas",
              component: () =>
                import("../views/children/CRUDS/Areas/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "AreaShow",
              component: () => import("../views/children/CRUDS/Areas/Show.vue"),
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "AreaEdit",
              component: () => import("../views/children/CRUDS/Areas/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "AreaAdd",
              component: () => import("../views/children/CRUDS/Areas/Form.vue"),
            },
          ],
        },
        // ******* End Areas *******

        // ******* Start saved-circles *******
        {
          path: "/savedCircles",
          component: () =>
            import("../views/children/CRUDS/SavedCircle/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllSavedCircles",
              component: () =>
                import("../views/children/CRUDS/SavedCircle/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "SavedCircleShow",
              component: () =>
                import("../views/children/CRUDS/SavedCircle/Show.vue"),
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "SavedCircleEdit",
              component: () =>
                import("../views/children/CRUDS/SavedCircle/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "SavedCircleAdd",
              component: () =>
                import("../views/children/CRUDS/SavedCircle/Form.vue"),
            },
          ],
        },
        // ******* End saved-circles *******

        // ******* Start Egypt Post *******
        {
          path: "/egyptPost",
          component: () => import("../views/children/CRUDS/EgyptPost/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllEgyptPosts",
              component: () =>
                import("../views/children/CRUDS/EgyptPost/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "EgyptPostShow",
              component: () =>
                import("../views/children/CRUDS/EgyptPost/Show.vue"),
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "EgyptPostEdit",
              component: () =>
                import("../views/children/CRUDS/EgyptPost/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "EgyptPostAdd",
              component: () =>
                import("../views/children/CRUDS/EgyptPost/Form.vue"),
            },
          ],
        },
        // ******* End Egypt Post *******

        // ******* Start Banks *******
        {
          path: "/banks",
          component: () => import("../views/children/CRUDS/Banks/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllBanks",
              component: () =>
                import("../views/children/CRUDS/Banks/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "BankShow",
              component: () => import("../views/children/CRUDS/Banks/Show.vue"),
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "BankEdit",
              component: () => import("../views/children/CRUDS/Banks/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "BankAdd",
              component: () => import("../views/children/CRUDS/Banks/Form.vue"),
            },
          ],
        },
        // ******* End Banks *******

        // ******* Start Chat Questions *******
        {
          path: "/caht_questions",
          component: () =>
            import("../views/children/CRUDS/ChatQuestions/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllChatQuestions",
              component: () =>
                import("../views/children/CRUDS/ChatQuestions/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "ChatQuestionShow",
              component: () =>
                import("../views/children/CRUDS/ChatQuestions/Show.vue"),
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "ChatQuestionEdit",
              component: () =>
                import("../views/children/CRUDS/ChatQuestions/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "ChatQuestionAdd",
              component: () =>
                import("../views/children/CRUDS/ChatQuestions/Form.vue"),
            },
          ],
        },
        // ******* End Chat Questions *******

        // ******* Start User Classes *******
        {
          path: "/userClasses",
          component: () =>
            import("../views/children/CRUDS/UserClasses/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllUserClasses",
              component: () =>
                import("../views/children/CRUDS/UserClasses/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "UserClassShow",
              component: () =>
                import("../views/children/CRUDS/UserClasses/Show.vue"),
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "UserClassEdit",
              component: () =>
                import("../views/children/CRUDS/UserClasses/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "UserClassAdd",
              component: () =>
                import("../views/children/CRUDS/UserClasses/Form.vue"),
            },
          ],
        },
        // ******* End User Classes *******

        // ******* Start Services *******
        {
          path: "/services",
          component: () => import("../views/children/CRUDS/Services/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllServices",
              component: () =>
                import("../views/children/CRUDS/Services/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "ServiceShow",
              component: () =>
                import("../views/children/CRUDS/Services/Show.vue"),
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "ServiceEdit",
              component: () =>
                import("../views/children/CRUDS/Services/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "ServiceAdd",
              component: () =>
                import("../views/children/CRUDS/Services/Form.vue"),
            },
          ],
        },
        // ******* End Services *******

        // ******* Start Goals *******
        {
          path: "/goals",
          component: () => import("../views/children/CRUDS/Goals/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllGoals",
              component: () =>
                import("../views/children/CRUDS/Goals/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "GoalShow",
              component: () => import("../views/children/CRUDS/Goals/Show.vue"),
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "GoalEdit",
              component: () => import("../views/children/CRUDS/Goals/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "GoalAdd",
              component: () => import("../views/children/CRUDS/Goals/Form.vue"),
            },
          ],
        },
        // ******* End Goals *******

        // ******* Start Offers *******
        {
          path: "/offers",
          component: () => import("../views/children/CRUDS/Offers/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllOffers",
              component: () =>
                import("../views/children/CRUDS/Offers/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "OfferShow",
              component: () =>
                import("../views/children/CRUDS/Offers/Show.vue"),
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "OfferEdit",
              component: () =>
                import("../views/children/CRUDS/Offers/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "OfferAdd",
              component: () =>
                import("../views/children/CRUDS/Offers/Form.vue"),
            },
          ],
        },
        // ******* End Offers *******

        // ******* Start Circles *******
        {
          path: "/circles",
          component: () => import("../views/children/CRUDS/Circles/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllCircles",
              component: () =>
                import("../views/children/CRUDS/Circles/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "CircleShow",
              component: () =>
                import("../views/children/CRUDS/Circles/Show.vue"),
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "CircleEdit",
              component: () =>
                import("../views/children/CRUDS/Circles/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "CircleAdd",
              component: () =>
                import("../views/children/CRUDS/Circles/Form.vue"),
            },
          ],
        },
        // ******* End Circles *******

        // ******* Start Sub Circles *******
        {
          path: "/subCircles",
          component: () => import("../views/children/CRUDS/SubCircle/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all/:circleId",
              name: "AllSubCircles",
              component: () =>
                import("../views/children/CRUDS/SubCircle/ShowAll.vue"),
              props: true,
            },
            {
              path: "AllSubCircles",
              name: "AllSubCircles",
              component: () =>
                import("../views/children/CRUDS/SubCircle/AllSubCircles.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "SubCircleShow",
              component: () =>
                import("../views/children/CRUDS/SubCircle/Show.vue"),
              props: true,
            },
            // Edit
            {
              path: "edit/:id/circle/:circleId",
              name: "SubCircleEdit",
              component: () =>
                import("../views/children/CRUDS/SubCircle/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add/:circleId?",
              name: "add-sub-circle",
              component: () =>
                import("../views/children/CRUDS/SubCircle/Form.vue"),
              props: true,
            },
          ],
        },
        // ******* End Sub Circles *******
        // ******* Start Sub Saved Circles *******
        {
          path: "/sub-saved",
          component: () =>
            import("../views/children/CRUDS/subSavedCircle/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all/:circleId",
              name: "AllSubSavedCircles",
              component: () =>
                import("../views/children/CRUDS/subSavedCircle/ShowAll.vue"),
              props: true,
            },
            // Show Single
            {
              path: "show/:id",
              name: "SubSavedCircleShow",
              component: () =>
                import("../views/children/CRUDS/subSavedCircle/Show.vue"),
              props: true,
            },
            // Edit
            {
              path: "edit/:id/circle/:circleId",
              name: "SubSavedCircleEdit",
              component: () =>
                import("../views/children/CRUDS/subSavedCircle/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add/:circleId?",
              name: "add-sub-saved-circle",
              component: () =>
                import("../views/children/CRUDS/subSavedCircle/Form.vue"),
              props: true,
            },
          ],
        },
        // ******* End Sub Saved Circles *******

        // ******* Start Slider *******
        {
          path: "/slider",
          component: () => import("../views/children/CRUDS/Slider/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllSliders",
              component: () =>
                import("../views/children/CRUDS/Slider/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "SliderShow",
              component: () =>
                import("../views/children/CRUDS/Slider/Show.vue"),
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "SliderEdit",
              component: () =>
                import("../views/children/CRUDS/Slider/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "SliderAdd",
              component: () =>
                import("../views/children/CRUDS/Slider/Form.vue"),
            },
          ],
        },
        // ******* End Slider *******
        // ******* Start faq *******

        // ******* End faq *******
        // ******* Start payment-policy *******
        {
          path: "/payment-policy",
          component: () =>
            import("../views/children/CRUDS/payment-policy/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "Allpayment-policy",
              component: () =>
                import("../views/children/CRUDS/payment-policy/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "payment-policyShow",
              component: () =>
                import("../views/children/CRUDS/payment-policy/Show.vue"),
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "payment-policyEdit",
              component: () =>
                import("../views/children/CRUDS/payment-policy/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "payment-policyAdd",
              component: () =>
                import("../views/children/CRUDS/payment-policy/Form.vue"),
            },
          ],
        },
        // ******* End payment-policy *******
        // ******* Start level-benefits *******
        {
          path: "/level-benefits",
          component: () =>
            import("../views/children/CRUDS/level-benefits/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "Alllevel-benefits",
              component: () =>
                import("../views/children/CRUDS/level-benefits/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "level-benefitsShow",
              component: () =>
                import("../views/children/CRUDS/level-benefits/Show.vue"),
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "level-benefitsEdit",
              component: () =>
                import("../views/children/CRUDS/level-benefits/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "level-benefitsAdd",
              component: () =>
                import("../views/children/CRUDS/level-benefits/Form.vue"),
            },
          ],
        },
        // ******* End level-benefits *******
        // ******* Start user-documents *******
        {
          path: "/user-documents/:id",
          component: () =>
            import("../views/children/CRUDS/user-documents/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "Alluser-documents",
              component: () =>
                import("../views/children/CRUDS/user-documents/ShowAll.vue"),
            },
            // Show Single
          ],
        },
        // ******* End user-documents *******

        // ******* Start Points *******
        {
          path: "/points",
          component: () => import("../views/children/CRUDS/Points/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllPoints",
              component: () =>
                import("../views/children/CRUDS/Points/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "PointShow",
              component: () =>
                import("../views/children/CRUDS/Points/Show.vue"),
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "PointEdit",
              component: () =>
                import("../views/children/CRUDS/Points/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "PointAdd",
              component: () =>
                import("../views/children/CRUDS/Points/Form.vue"),
            },
          ],
        },
        // ******* End Points *******

        // ******* Start Admins *******
        {
          path: "/clients",
          component: () => import("@/views/children/CRUDS/Clients/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllClients",
              component: () =>
                import("@/views/children/CRUDS/Clients/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "Clientshow",
              component: () =>
                import("@/views/children/CRUDS/Clients/Show.vue"),
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "clientEdit",
              component: () =>
                import("@/views/children/CRUDS/Clients/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "clientAdd",
              component: () =>
                import("@/views/children/CRUDS/Clients/Form.vue"),
            },
          ],
        },
        // ******* End Admins *******

        // ******* Start agents *******
        {
          path: "/admins",
          component: () => import("@/views/children/CRUDS/Admins/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllAdmins",
              component: () =>
                import("@/views/children/CRUDS/Admins/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "AdminShow",
              component: () => import("@/views/children/CRUDS/Admins/Show.vue"),
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "AdminEdit",
              component: () => import("@/views/children/CRUDS/Admins/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "AdminAdd",
              component: () => import("@/views/children/CRUDS/Admins/Form.vue"),
            },
          ],
        },
        // ******* End agents *******
        // ******* Start notifications *******
        {
          path: "/notifications",
          component: () =>
            import("@/views/children/CRUDS/notifications/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "all-notifications",
              component: () =>
                import("@/views/children/CRUDS/notifications/ShowAll.vue"),
            },
            // Show Single

            {
              path: "add",
              name: "add-notification",
              component: () =>
                import("@/views/children/CRUDS/notifications/Form.vue"),
            },
          ],
        },
        // ******* End notifications *******

        // ******* Start  Permission *******
        {
          path: "/permissions",
          component: () =>
            import("@/views/children/CRUDS/Permissions/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllPermissions",
              component: () =>
                import("@/views/children/CRUDS/Permissions/ShowAll.vue"),
            },
            // Show Single

            // Edit
            {
              path: "edit/:id",
              name: "EditPermission",
              component: () =>
                import("@/views/children/CRUDS/Permissions/Form.vue"),
              props: true,
            },
            // Edit
            {
              path: "add",
              name: "AddPermission",
              component: () =>
                import("@/views/children/CRUDS/Permissions/Form.vue"),
            },
          ],
        },
        // ******* End  Permission *******
        // ******* Start  permissions-labels *******
        {
          path: "/permission-labels",
          component: () =>
            import("@/views/children/CRUDS/PermissionLabels/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "all-permission-labels",
              component: () =>
                import("@/views/children/CRUDS/PermissionLabels/ShowAll.vue"),
            },
            // Show Single

            // Edit
            {
              path: "edit/:id",
              name: "edit-permission-label",
              component: () =>
                import("@/views/children/CRUDS/PermissionLabels/Form.vue"),
              props: true,
            },
            // Edit
            {
              path: "add",
              name: "add-permission-label",
              component: () =>
                import("@/views/children/CRUDS/PermissionLabels/Form.vue"),
            },
          ],
        },
        // ******* End  roles *******
        // ******* Start  roles *******
        {
          path: "/roles",
          component: () => import("@/views/children/CRUDS/Roles/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "all-roles",
              component: () =>
                import("@/views/children/CRUDS/Roles/ShowAll.vue"),
            },
            // Show Single

            // Edit
            {
              path: "edit/:id",
              name: "edit-role",
              component: () => import("@/views/children/CRUDS/Roles/Form.vue"),
              props: true,
            },
            // Edit
            {
              path: "add",
              name: "add-role",
              component: () => import("@/views/children/CRUDS/Roles/Form.vue"),
            },
          ],
        },
        // ******* End  permissions-categories *******
        // ******* Start  permissions-categories *******
        {
          path: "/permission-categories",
          component: () =>
            import("@/views/children/CRUDS/PermissionCategory/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "all-permission-category",
              component: () =>
                import("@/views/children/CRUDS/PermissionCategory/ShowAll.vue"),
            },
            // Show Single

            // Edit
            {
              path: "edit/:id",
              name: "edit-permission-category",
              component: () =>
                import("@/views/children/CRUDS/PermissionCategory/Form.vue"),
              props: true,
            },
            // Edit
            {
              path: "add",
              name: "add-permission-category",
              component: () =>
                import("@/views/children/CRUDS/PermissionCategory/Form.vue"),
            },
          ],
        },
        // ******* End  permissions-categories *******
        // ******* Start  point-settings *******
        {
          path: "/point-settings",
          component: () =>
            import("@/views/children/CRUDS/point-settings/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "all-point-settings",
              component: () =>
                import("@/views/children/CRUDS/point-settings/ShowAll.vue"),
            },
            // Show Single

            // Edit
            {
              path: "edit/:id",
              name: "edit-point-settings",
              component: () =>
                import("@/views/children/CRUDS/point-settings/Form.vue"),
              props: true,
            },
            // Edit
            {
              path: "add",
              name: "add-point-settings",
              component: () =>
                import("@/views/children/CRUDS/point-settings/Form.vue"),
            },
          ],
        },
        // ******* End  point-settings *******

        // ******* Start Schools *******
        {
          path: "/education_entities",
          component: () => import("../views/children/CRUDS/Schools/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllEducationEntities",
              component: () =>
                import("../views/children/CRUDS/Schools/ShowAll.vue"),
            },
            // Edit
            {
              path: "edit/:id",
              name: "EducationEntityEdit",
              component: () =>
                import("../views/children/CRUDS/Schools/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "EducationEntityAdd",
              component: () =>
                import("../views/children/CRUDS/Schools/Form.vue"),
            },
          ],
        },
        // ******* End Schools *******

        // ******* Start Cancel Reason *******
        {
          path: "/cancel_reasons",
          component: CancelReasonsHome,
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllCancelReasons",
              component: AllCancelReasons,
            },
            // Show Single
            {
              path: "show/:id",
              name: "CancelReasonShow",
              component: CancelReasonShow,
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "CancelReasonEdit",
              component: CancelReasonForm,
              props: true,
            },
            // Add
            {
              path: "add",
              name: "CancelReasonAdd",
              component: CancelReasonForm,
            },
          ],
        },
        // ******* End Cancel Reason *******

        // ******* Start Report Reasons *******
        {
          path: "/report_reasons",
          component: ReportReasonsHome,
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllReportReasons",
              component: AllReportReasons,
            },
            // Show Single
            {
              path: "show/:id",
              name: "ReportReasonShow",
              component: ReportReasonShow,
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "ReportReasonEdit",
              component: ReportReasonForm,
              props: true,
            },
            // Add
            {
              path: "add",
              name: "ReportReasonAdd",
              component: ReportReasonForm,
            },
          ],
        },
        // ******* End Report Reasons *******

        // // ******* Start withdraw *******
        {
          path: "/withdraw",
          component: () => import("@/views/children/CRUDS/withdraw/Home.vue"),

          children: [
            // Show All
            {
              path: "show-all",
              name: "AllWithdraws",
              component: () =>
                import("@/views/children/CRUDS/withdraw/ShowAll.vue"),
            },
          ],
        },
        // ******* End withdraw *******
        // // ******* Start Update Requests *******
        {
          path: "/update-requests",
          component: () =>
            import("@/views/children/CRUDS/UpdateRequests/Home.vue"),

          children: [
            // Show All
            {
              path: "show-all",
              name: "AllRequests",
              component: () =>
                import("@/views/children/CRUDS/UpdateRequests/ShowAll.vue"),
            },
            // Show
            {
              path: "show/:id",
              name: "ShowRequest",
              component: () =>
                import("@/views/children/CRUDS/UpdateRequests/Show.vue"),
              props: true,
            },
          ],
        },
        // ******* End Update Requests *******

        // ******* Start Live  Chat*******
        {
          path: "/chats/:id?",
          component: () => import("@/views/children/Chat/Index.vue"),
          name: "chats",
          props: true,
        },
        // ******* End  Live  Chat *******

        // ============================== End CRUDS ==============================

        // ========== Start StaticScreens ==========
        {
          path: "/static-screens",
          name: StaticScreens,
          component: StaticScreens,
        },
        // ========== End StaticScreens ==========

        // ========== Start Settings ==========
        // ***** Anout Us
        {
          path: "/about",
          component: AboutUsHome,
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllAboutUs",
              component: AboutUsForm,
            },
            // Edit
            {
              path: "edit/:id",
              name: "AboutUsEdit",
              component: AboutUsForm,
              props: true,
            },
            // Add
            {
              path: "add",
              name: "AboutUsAdd",
              props: true,
              component: AboutUsForm,
            },
          ],
        },
        // ***** Faq
        {
          path: "/faq",
          component: () => import("@/views/children/CRUDS/faq/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllFaqs",
              component: () => import("@/views/children/CRUDS/faq/ShowAll.vue"),
            },
            // Edit
            {
              path: "edit/:id",
              name: "editAdd",
              component: () => import("@/views/children/CRUDS/faq/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "faqAdd",
              component: () => import("@/views/children/CRUDS/faq/Form.vue"),
            },
          ],
        },
        // ***** Terms
        {
          path: "/terms",
          component: TermsHome,
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllTerms",
              component: TermsForm,
            },
            // Edit
            {
              path: "edit/:id",
              name: "TermsEdit",
              component: TermsForm,
              props: true,
            },
            // Add
            {
              path: "add",
              name: "TermsAdd",
              component: TermsForm,
            },
          ],
        },

        // ***** Policy
        {
          path: "/policy",
          component: PolicyHome,
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllPolicy",
              component: PolicyForm,
            },
            // Edit
            {
              path: "edit/:id",
              name: "PolicyEdit",
              component: PolicyForm,
              props: true,
            },
            // Add
            {
              path: "add",
              name: "PolicyAdd",
              component: PolicyForm,
            },
          ],
        },

        // ***** Contact
        {
          path: "/settings",
          component: () => import("../views/children/Settings/Home.vue"),
          children: [
            {
              path: "",
              name: "mainSettings",
              component: () => import("../views/children/Settings/General.vue"),
            },
            {
              path: "social",
              name: "socialSettings",
              component: () => import("../views/children/Settings/Social.vue"),
            },
            {
              path: "sms",
              name: "sms",
              component: () =>
                import("../views/children/Settings/SmsServices.vue"),
            },
            {
              path: "order-setting",
              name: "order-setting",
              component: () => import("../views/children/Settings/Orders.vue"),
            },
            {
              path: "app-links",
              name: "app-links",
              component: () =>
                import("../views/children/Settings/AppLinks.vue"),
            },
          ],
        },
        // ========== End Settings ==========

        // ========== Start Profiles ==========
        {
          path: "/profile",

          component: () => import("@/views/children/adminProfile/Home.vue"),
          children: [
            {
              path: "show",
              name: "showProfile",
              component: () => import("@/views/children/adminProfile/Show.vue"),
            },
            {
              path: "edit",
              name: "editProfile",
              component: () => import("@/views/children/adminProfile/Form.vue"),
            },
            {
              path: "password",
              name: "changePassword",
              component: () =>
                import("@/views/children/adminProfile/ChangePassword.vue"),
            },
          ],
        },
        // ========== End Profiles ==========

        // ========== Start Reference==========
        {
          path: "/reference",
          name: "Reference",
          component: Reference,
        },
        // ========== End Reference ==========

        // ========== Start Chat ==========
        {
          path: "/financial_reports",
          name: "FinancialReports",
          component: () =>
            import("../views/children/FinancialReports/Home.vue"),
        },
        // ========== Start Chat ==========

        // ========== End Chat ==========

        // ========== Start DriversTracking ==========
        // {
        //   path: '/drivers_tracking',
        //   name: 'DriversTracking',
        //   component: DriversTracking,
        // },
        // ========== End DriversTracking ==========
      ],
    },
    {
      path: "/permission-required",
      name: "permission-required",
      component: () => import("../views/PermissionRequired.vue"),
    },

    //  =========== Start Redirects ===============
    {
      path: "/countries",

      redirect: () => {
        return { path: "/countries/show-all" };
      },
    },
    {
      path: "/about",

      redirect: () => {
        return { path: "/about/show-all" };
      },
    },
    {
      path: "/terms",

      redirect: () => {
        return { path: "/terms/show-all" };
      },
    },
    {
      path: "/privacy",

      redirect: () => {
        return { path: "/privacy/show-all" };
      },
    },
    {
      path: "/about/add",

      redirect: () => {
        return { path: "/about/show-all" };
      },
    },
    {
      path: "/terms/add",

      redirect: () => {
        return { path: "/terms/show-all" };
      },
    },
    {
      path: "/privacy/add",

      redirect: () => {
        return { path: "/privacy/show-all" };
      },
    },
    //  =========== End  Redirects ===============

    // Standalone Policy Page
    {
      path: "/privacy-policy",
      name: "PrivacyPolicy",
      component: PolicyPage,
    },

    // Auth
    {
      path: "/login",
      name: "Login",
      component: Login,
    },

    // NotFound
    { path: "/:notFound(.*)", name: "NotFound", component: NotFound },
  ],
});

const TOKEN = store.getters["auth_module/currentUser"].token;

router.beforeEach((to, _2, next) => {
  // Allow access to Login and PrivacyPolicy routes without authentication
  if (to.name !== "Login" && to.name !== "PrivacyPolicy" && !TOKEN) {
    next({ name: "Login" });
  } else if (to.name == "Login" && TOKEN) {
    next("/");
  } else {
    next();
  }
});

Vue.use(VueRouter);
export default router;

